import axios from 'axios';

const BASE_URL = import.meta.env.VITE_APP_API || 'http://localhost:5000/';
const API_STATUS_SUCCESS = 0;

const http = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

function unwrap(response) {
  const body = response?.data;
  if (body && typeof body === 'object' && ('status' in body || 'Status' in body)) {
    const status = 'status' in body ? body.status : body.Status;
    const data = 'data' in body ? body.data : body.Data;
    if (status === API_STATUS_SUCCESS) return data;

    const error = new Error(body.message || body.Message || 'Request failed');
    error.status = status;
    error.data = data;
    throw error;
  }
  return body;
}

function toError(error) {
  const body = error?.response?.data;
  const normalized = new Error(body?.message || body?.Message || error?.message || 'Request failed');
  normalized.httpStatus = error?.response?.status;
  normalized.status = body?.status ?? body?.Status;
  normalized.data = body?.data ?? body?.Data;
  return normalized;
}

async function get(url) {
  try {
    return unwrap(await http.get(url));
  } catch (error) {
    throw error?.httpStatus === undefined && error?.status !== undefined ? error : toError(error);
  }
}

async function post(url, payload) {
  try {
    return unwrap(await http.post(url, payload));
  } catch (error) {
    throw error?.httpStatus === undefined && error?.status !== undefined ? error : toError(error);
  }
}

export const taxProductDisplayConfigApi = {
  getConfig() {
    return get('api/v1/GetTaxProductDisplayConfig');
  },
  updateConfig(payload) {
    return post('api/v1/UpdateTaxProductDisplayConfig', payload);
  },
  // Drops the server-side 10-minute cache behind GetRecommendedProducts, so the mobile
  // screen picks up a change that was made outside this dialog without waiting it out.
  clearRecommendedProductsCache() {
    return post('api/v1/ClearTaxRecommendedProductsCache', {});
  },
};
